import React from "react";
import {ErrorMessage, Field, Form, Formik} from "formik";

import Email from "../../images/email.svg";
import Arrow from "../../images/arrow_right.svg";

import LazyLoad from 'react-lazyload';

import Logger from "../../components/utils/Logger";

const Subscribe = () => {
  return (
    <section id="subscribe">
      <svg className="svg-rot" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
           preserveAspectRatio="none">
        <path fill="#0090FF" d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="shape-fill"/>
      </svg>
      <div className="px-4 py-4 container-fluid">
        <div className="row no-gutters">
          <div className="col-10 offset-1 text-center">
            <h2>SUBSCRIBE</h2>
            <hr className="hr-line1"/>
            <h4>...and you will not miss an update!</h4>
            <Formik
              initialValues={{email: ''}}
              validate={values => {
                const errors = {};
                if (!values.email) {
                  errors.email = 'Required';
                } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
                  errors.email = 'Invalid';
                }
                return errors;
              }}
              onSubmit={(values, {setSubmitting, resetForm}) => {
                Logger.log(values);
                alert('Thank You for the good intentions but email subscriptions are not working yet!');
                resetForm();
              }}
            >
              {({
                  handleSubmit,
                  handleReset,
                  isSubmitting,
                  isValid,
                }) => (
                <Form onSubmit={handleSubmit} onReset={handleReset} className="mt-5 position-relative">
                  <div className="form-group d-flex align-items-center justify-content-center">
                    <label htmlFor="name" className="col-form-label"/>
                    <Field type="email" name="email" id="inputEmail" placeholder="Email Address..."
                           className="form-control" maxLength="100"/>
                    <button type="submit" disabled={isSubmitting || !isValid}
                            className="btn btn-primary btn-scale my-0 ml-2 px-3">
                      <LazyLoad once={true}>
                        <img src={Arrow} alt="arrow" className="subscribe-btn" />
                      </LazyLoad>
                    </button>
                  </div>
                  <ErrorMessage name="email" component="div" className="invalid-value subscribe-error"/>
                </Form>
              )}
            </Formik>
          </div>
          <LazyLoad once={true}>
            <img className="subscribe-img" src={Email} alt="email"/>
          </LazyLoad>
        </div>
      </div>
    </section>
  )
};

export default Subscribe;